import { TitleGroupComponent } from 'components/title/title-group-component';
import { Row, Col, Button, Badge, Card, Form, FormControl, Modal, Pagination, Table, Tooltip } from 'react-bootstrap';
import { BsFillCartFill, BsSliders, BsTag } from 'react-icons/bs';
import { Footer } from 'components/footer/footer-component';
import { ParseDateToBrV2 } from 'helper/format-date-helper';
import { AiFillLock } from 'react-icons/ai';
import ReactTooltip from 'react-tooltip';
import { orderValueColums } from 'helper/table-columns-helper';
import { getParameterUrlByName, parseLinkHeader } from 'helper/request-helper';
import { getEnv } from 'helper/window-helper';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import { ModalOrderHideColumns } from './components/modal/modal-order-hide-columns-component';
import { getLocalStorage, updateLocalStorege } from 'data/cache/localstorage-cache';
import { LinkHeader } from '../../../@types/interfaces/link-header-interface';
import { ColumnsActiveCampaignAdapter } from 'helper/adapter/columsTable/columns-table-active-campaign-adapter';
import Select from 'react-select';
import { SelectOptionInterface } from '../../../@types/entity/interface/select-option-interface';
import { FaDotCircle } from 'react-icons/fa';
import { FiAlertTriangle } from 'react-icons/fi';
import { GrCircleInformation, GrStatusCritical } from 'react-icons/gr';
import { HiBell } from 'react-icons/hi';
import { MdMapsHomeWork, MdAttachMoney } from 'react-icons/md';
import { ModalPlanning } from './components/modal/modal-planning-component';
import { FiltersDefault } from '../../../@types/interfaces/filter-interface';
import { ModalIcon } from './components/modal/modal-icon-component';
import { TableHeaderStyled } from 'pages/style/table/table-header';
import { LineChart, CartesianGrid, XAxis, YAxis, Legend, Line } from 'recharts';
import { ModalConfirmAction } from 'components/modal/modal-confirm-action-component';
import { BiColumns } from 'react-icons/bi';
import '../../style/analysis/active-campaigns.css';
import { ActiveCampaignTotalsCard } from './components/active-campaignd-totals-card-compnent';
import { UseAlert } from 'hook/alert-hook';
import { CreateIconOrder } from './components/create-icon-order-component';
import { ActiveCampaignTotals } from '../../../@types/interfaces/analysis/active-campaign/active-campaign-totals-interface';
import { useLoader } from "components/loader/loader-context";
import { TableDescriptions } from "@interfaces/table-interface";
import { DadosPii } from '@interfaces/analysis/campaign-pii-data';
import { ModalCampaignPiiData } from './components/modal/modal-campaign-pii-data';
 
type Props = {
  isLoadingModal: boolean;
  loggedUserDataRole: string[];
  listAnalitycal: (params: { pagination: string; model?: any }) => Promise<any>;
  list: (params: { pagination: string; model?: any; idBranch?: number; idCampaign?: number }) => Promise<any>;
  save: (params: { idIntencao: number; item: any[] }) => Promise<any>;
  getActiveCampaignsTotals: (idIntencao: number, idBranch: number, idCampaign: number) => Promise<any>;
  getExcel: (idBranch: number, idCampaign: number, columns: TableDescriptions[]) => Promise<any>;
  removePendingQuantities: (idIntencao: number) => Promise<any>;
  sendOrder: (idIntencao: number, idBranch: number, idCampaign: number, dadosPii?: DadosPii) => Promise<any>;
  requestOrder: (idIntencao: number, orderName?: string) => Promise<any>;
  branchOptions: SelectOptionInterface[] | undefined;
  campaignsOptions: SelectOptionInterface[] | undefined;
  meliOptions: SelectOptionInterface[] | undefined;
  findCampaigns: (idBranch: number) => Promise<any>;
  createPlanning: (params?: any) => Promise<any>;
  editPlanning: (params?: any) => Promise<any>;
  removePlanning: (params?: any) => Promise<any>;
  listAllPlanning: (params?: any) => Promise<any>;
  optionsFiltersDefault: FiltersDefault[];
  graphicHistory: (params?: any) => Promise<any>;
  observationItem: (params?: any) => Promise<any>;
  movement: (params?: any) => Promise<any>;
  correlate: (params?: any) => Promise<any>;
  fluxoAprovacao: boolean | null;
};

export const ActiveCampaignsPage: React.FC<Props> = ({
  isLoadingModal,
  loggedUserDataRole,
  listAnalitycal,
  list,
  save,
  getActiveCampaignsTotals,
  getExcel,
  removePendingQuantities,
  sendOrder,
  requestOrder,
  branchOptions,
  campaignsOptions,
  meliOptions,
  findCampaigns,
  createPlanning,
  editPlanning,
  removePlanning,
  listAllPlanning,
  optionsFiltersDefault,
  graphicHistory,
  observationItem,
  movement,
  correlate,
  fluxoAprovacao,
}) => {
  const LOCALSTORAGE_COLUMS = getEnv('REACT_APP_LOCALSTORAGE_COLUMS_ACTIVE_CAMPAIGN')!;
  const LOCALSTORAGE_COLUMS_ORDER = getEnv('REACT_APP_LOCALSTORAGE_COLUMS_ACTIVE_CAMPAIGN')! + '_order';
  const LOCALSTORAGE_PLANNING = getEnv('REACT_APP_LOCALSTORAGE_PLANNING_ACTIVE_CAMPAIGN')!;

  const { showAlert } = UseAlert();
  const { showLoader, hideLoader } = useLoader();

  const titlePage = 'Campanhas Ativas';
  let freeze: boolean = false;
  let freezeBody: boolean = false;

  let firstCol: string = 'first-col-active-campaign';
  let secondCol: string = 'second-col-active-campaign';
  let thirdCol: string = 'third-col-active-campaign';
  let fouthCol: string = 'fourth-col-active-campaign';
  let fifthCol: string = 'fifth-col-active-campaign';
  let sixthCol: string = 'sixth-col-active-campaign';
  let seventhCol: string = 'seventh-col-active-campaign';
  let firstColHeader: string = 'first-col-header-active-campaign';
  let secondColHeader: string = 'second-col-header-active-campaign';
  let thirdColHeader: string = 'third-col-header-active-campaign';
  let fourthColHeader: string = 'fourth-col-header-active-campaign';
  let fifthColHeader: string = 'fifth-col-header-active-campaign';
  let sixthColHeader: string = 'sixth-col-header-active-campaign';
  let seventhColHeader: string = 'seventh-col-header-active-campaign';
  let freezeCss: string = '';

  const [planningName, updatePlanningName] = useState<string | null>(null)

  const [branchSelected, updateBranchSelected] = useState<SelectOptionInterface | null>();
  const [campaignSelected, updateCampaignSelected] = useState<SelectOptionInterface>();
  const [activeCampaigntotals, updateActiveCampaigntotals] = useState<ActiveCampaignTotals>();
  const [previousQuantity, updatePreviousQuatity] = useState<number>();

  const [page, updatePage] = useState<number>(0);
  const [totalPageSize, updateTotalPageSize] = useState<number>(13);
  const [paginationFixed, updatePaginationFixed] = useState<string>(`?page=${0}&size=${totalPageSize}`);
  const [firstPagination, updateFirstPagination] = useState<string>('');
  const [lastPagination, updateLastPagination] = useState<string>('');
  const [nextPagination, updateNextPagination] = useState<string>('');
  const [prevPagination, updatePrevPagination] = useState<string>('');
  const [paginationItemList, updatePaginationItemList] = useState<{ item: number; active: boolean }[]>();

  const [showModalIcon, updateShowModalIcon] = useState(false);
  const [typeModalIcon, updateTypeModalIcon] = useState<string>();
  const [dataModalIcon, updateDataModalIcon] = useState<ReactNode>(<></>);
  const [dataRowModalIcon, updateDataRowModalIcon] = useState<any>();

  const [columns, updateColumns] = useState<TableDescriptions[]>(getLocalStorage(LOCALSTORAGE_COLUMS) ?? ColumnsActiveCampaignAdapter);
  const [listTable, updateListTable] = useState<any[]>([]);
  const [listOriginalDataTable, updateListOriginalDataTable] = useState<any[]>([]);
  const [idIntencaoCompra, updateIdIntencaoCompra] = useState<number>();

  const [showModalPlanning, updateShowModalPlanning] = useState(false);
  const [itemPlanning, updateItemPlanning] = useState<number>(0);
  const closePlanning = () => updateShowModalPlanning(false);
  const showPlanning = () => updateShowModalPlanning(true);

  const showIcon = () => updateShowModalIcon(true);

  const [showModalColumns, updateShowModalColumns] = useState(false);
  const closeColumn = () => updateShowModalColumns(false);
  const showColumn = () => updateShowModalColumns(true);

  const [showModalNomePedido, updateShowModalNomePedido] = useState(false);
  const [nomePedido, updateNomePedido] = useState('');
  const [showModalConfirmAction, updateShowModalConfirmAction] = useState(false);
  const openModalConfirmAction = () => updateShowModalConfirmAction(true);
  const closeModalConfirmAction = () => {
    updateShowModalConfirmAction(false);
    updateDadosPiiSend(undefined);
  };

  const [showModalPii, updateShowModalPii] = useState(false);
  const [dadosPiiSend, updateDadosPiiSend] = useState<DadosPii | undefined>(undefined);
  const openModalPii = () => updateShowModalPii(true);
  const closeModalPii = () => updateShowModalPii(false);

  const [callList, updateCallList] = useState(false);

  useEffect(() => {
    const columsLocalStorage = getLocalStorage(LOCALSTORAGE_COLUMS);
    const planningLocalStorage = getLocalStorage(LOCALSTORAGE_PLANNING);

    if (planningLocalStorage) 
      updateItemPlanning(planningLocalStorage.length - 1);
    if (columsLocalStorage) 
      updateColumns(columsLocalStorage.sort((a: { order: number }, b: { order: number }) => (a.order > b.order ? 1 : -1)));

    updateLocalStorege(LOCALSTORAGE_COLUMS_ORDER, []);
  }, []);

  useEffect(() => {
    if (branchSelected !== null && branchSelected !== undefined && campaignSelected !== null && campaignSelected !== undefined) {
      handleTable({ pagination: paginationFixed, page: page, size: totalPageSize });
    }
  }, [callList, updateCallList])

  useEffect(() => {
    if (typeModalIcon === 'Saldo') handleIconSaldo();
    if (typeModalIcon === 'Histórico') handleGraphicHistory();
    if (typeModalIcon === 'Venda') handlehandleMovement('venda');
    if (typeModalIcon === 'Compra') handlehandleMovement('compra');
    if (typeModalIcon === 'Correlatos') handlehandleCorrelate();
    if (typeModalIcon === 'Observação') handleObservationItem();
  }, [typeModalIcon, updateTypeModalIcon]);

  useEffect(() => {
    const namePage = 'active_campaigns';
    localStorage.setItem('actual_page', namePage);

    const local = getLocalStorage(LOCALSTORAGE_PLANNING);
    if (local !== null) {
      let countPlanning = local.length;
      updateItemPlanning(countPlanning);
    }
    updatePlanningName(localStorage.getItem('planning_name_' + namePage));
  }, [handleApplyPlanning]);

  const closeIcon = () => {
    updateShowModalIcon(false);
    updateTypeModalIcon('');
    updateDataModalIcon(<></>);
  };

  function handleSelectedBranch(val: SelectOptionInterface | null) {
    updateListTable([]);
    updateIdIntencaoCompra(undefined);
    updateCampaignSelected(undefined);
    updateBranchSelected(val);
    if (val !== null && val !== undefined) {
      findCampaigns(val.value);
    }
  }

  async function handleSelectedCampaign(val: SelectOptionInterface | null) {
    if (val !== null && val !== undefined) {
      updateCampaignSelected(val)
      await handleTable({ pagination: `?page=${0}&size=${totalPageSize}`, page: page, size: totalPageSize }, val.value);
    }
  }

  function handleRowValueUpdate(typeModalIcon: string, value: any) {
    let rowValue = listOriginalDataTable.find((e) => e.fitStrCodFabricante === value.fitStrCodFabricante);
    updateTypeModalIcon(typeModalIcon);
    updateDataRowModalIcon(rowValue);
  }

  function handleOrderHideColumns(columns: TableDescriptions[]) {
    updateLocalStorege(
      LOCALSTORAGE_COLUMS,
      columns.sort((a, b) => (a.order > b.order ? 1 : -1))
    );
    console.log("Aqui mostra as colunas 2: ", columns);
    updateColumns(columns.sort((a, b) => (a.order > b.order ? 1 : -1)));
  }

  const setValuePaginations = (paginationsActive: number, prev: number, next: number) => {
    let modelPaginationList: any[] = [];
    for (let index = paginationsActive; index < 6 + paginationsActive; index++) {
      if (!(index > next))
        modelPaginationList.push({
          item: index,
          active: index === paginationsActive ? true : false,
        });
    }
    updatePaginationItemList(modelPaginationList);
  };
  const onClickItemPagination = async (pagination: any) => {
    updateTotalPageSize(Number(getParameterUrlByName('size', nextPagination))!);
    updatePaginationFixed(`?page=${pagination.item}&size=${totalPageSize}`);
    updatePage(pagination.item);
    await handleTable({
      pagination: `?page=${pagination.item}&size=${totalPageSize}`,
      page: parseInt(pagination.item),
      size: totalPageSize,
    });
  };
  const onClickFirstPagination = async () => {
    const size: string = getParameterUrlByName('size', firstPagination)!;
    updatePaginationFixed(`?page=${0}&size=${size}`);
    updatePage(0);
    await handleTable({
      pagination: `?page=${0}&size=${size}`,
      page: 0,
      size: parseInt(size),
    });
  };
  const onClickLastPagination = async () => {
    const selectedPage = parseInt(getParameterUrlByName('page', lastPagination)!)
    const size: string = getParameterUrlByName('size', lastPagination)!;
    updatePage(selectedPage);
    updatePaginationFixed(`?page=${selectedPage}&size=${size}`);
    await handleTable({
      pagination: `?page=${selectedPage}&size=${size}`,
      page: selectedPage,
      size: parseInt(size),
    });
  };
  const onClickNextPagination = async () => {
    const selectedPage = parseInt(getParameterUrlByName('page', nextPagination)!)
    const size: string = getParameterUrlByName('size', nextPagination)!;
    updatePage(selectedPage);
    updatePaginationFixed(`?page=${selectedPage}&size=${size}`);
    await handleTable({
      pagination: `?page=${selectedPage}&size=${size}`,
      page: selectedPage,
      size: parseInt(size),
    });
  };
  const onClickPrevPagination = async () => {
    const selectedPage = parseInt(getParameterUrlByName('page', prevPagination)!)
    const size: string = getParameterUrlByName('size', prevPagination)!;
    updatePage(selectedPage);
    updatePaginationFixed(`?page=${selectedPage}&size=${size}`);
    await handleTable({
      pagination: `?page=${selectedPage}&size=${size}`,
      page: selectedPage,
      size: parseInt(size),
    });
  };

  const onClickExportarExcel = async () => {
    showLoader();
    try {
      const response = await getExcel(branchSelected?.value, campaignSelected?.value, columns)

      const url = window.URL.createObjectURL(new Blob([response.body]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `AnaliticoCampanhas.xlsx`);
      document.body.appendChild(link);
      link.click();
      link!.parentNode!.removeChild(link);
      showAlert({
        show: true,
        content: 'Exportado com sucesso',
        color: 'success',
        time: 2000,
      });
      hideLoader()
    } catch (error) {
      console.error('Error downloading Excel file:', error);
      showAlert({
        show: true,
        content: 'Erro ao tentar fazer o download do relatório de campanhas.',
        color: 'danger',
        time: 2000,
      });
      hideLoader()
    }
  };

  async function handleTable(params?: { pagination: string; page: number; size: number; ordination?: string; }, campaignId?: number) {
    let pagePagination = 0;
    let pagination;
    if (params) {
      pagination = params.pagination;
      pagePagination = params.page;
    } else {
      pagePagination = 0;
      pagination = `?page=${pagePagination}&size=${totalPageSize}`;
    }
    await list({
      pagination: pagination,
      idBranch: branchSelected?.value,
      idCampaign: campaignId ? campaignId : campaignSelected?.value,
    }).then((response) => {
      if (response.headers['link']) {
        let links: LinkHeader = parseLinkHeader(response.headers['link']) as any;

        updateFirstPagination(links.first);
        updateLastPagination(links.last);
        updateNextPagination(links.next);
        updatePrevPagination(links.prev);

        setValuePaginations(pagePagination, parseInt(getParameterUrlByName('page', links.first)!), parseInt(getParameterUrlByName('page', links.last)!));
      }
      if (response.success) {
        updateIdIntencaoCompra(response.data.idIntencaoCompra);
        updateListOriginalDataTable(response.data.analiticoCampanha);
        updateActiveCampaigntotals(response.data.totais);
        changeValueListByColums(response.data.analiticoCampanha);
      } else {
        changeValueListByColums([]);
        updateIdIntencaoCompra(undefined);
      }
    });
  }

  function changeValueListByColums(model: any[]) {
    if (model !== undefined) {
      var ListTableChanged: any[] = [];
      var columsName = columns
        .filter((value) => value.hidden === false || value.dataField === 'aacStrDeltaLegenda')
        .map((vl) => {
          return vl.dataField;
        });

      model.forEach((value) => {
        const filtered = Object.keys(value)
          .filter((key) => columsName.includes(key))
          .reduce((obj: any, key: any) => {
            obj[key] = value[key];
            return obj;
          }, {});

        ListTableChanged.push(filtered);
      });
      updateListTable(ListTableChanged);
    }
  }

  const handleOnFocusQuantity = () => async (event: React.FocusEvent<HTMLInputElement>) => {
    updatePreviousQuatity(parseInt(event.target.value));
  };

  async function handleInputBlurQuantity(event: any, value: any) {
    if (event.target.value === '') {
      event.target.value = 0;
    }
    let changedValue = Number(event.target.value);
    if (idIntencaoCompra !== null && idIntencaoCompra !== undefined && parseInt(event.target.value) !== previousQuantity) {
      value['qtdPendente'] = changedValue;
      let updatedItem = listOriginalDataTable.find((val) => val.fitStrCodFabricante === value['fitStrCodFabricante']);
      updatedItem.qtdPendente = changedValue;

      await save({ idIntencao: idIntencaoCompra!, item: [updatedItem] });
      updatePaginationFixed(`?page=${page}&size=${totalPageSize}`);
      updateCallList(!callList);
    }
  }

  async function confirmSendOrder() {
    const dadosPii = dadosPiiSend;
    updateShowModalConfirmAction(false);
    const response = await sendOrder(idIntencaoCompra!, branchSelected?.value, campaignSelected?.value, dadosPii);
    updateDadosPiiSend(undefined);
    if (response?.success) {
      updateCallList(!callList);
    }
  }

  function confirmPiiData(dadosPii: DadosPii) {
    updateDadosPiiSend(dadosPii);
    closeModalPii();
    openModalConfirmAction();
  }

  async function removeQuantities() {
    if (idIntencaoCompra !== null && idIntencaoCompra !== undefined) {
      await removePendingQuantities(idIntencaoCompra);
      updateCallList(!callList);
    }
  }

  async function handleApplyPlanning(model: any) {
    closePlanning();
    updateLocalStorege(LOCALSTORAGE_PLANNING, model);
    updateCallList(!callList);
  }

  async function handleIconSaldo() {
    let model = [
      {
        type: 'CODIGO_ITEM',
        params: { codigos: [dataRowModalIcon.fitStrCodFabricante] },
      },
      {
        type: 'FILIAL',
        params: { filiais: [dataRowModalIcon?.filIntIdFilial], type: 'NOT_IN' },
      },
    ];

    let response = await listAnalitycal({ pagination: `?page=${0}&size=${totalPageSize}`, model: model });
    if (response.statusCode !== 500) {
      let data = response.body;
      let dataRowModalIconDelta = dataRowModalIcon.arqFltCustoMedio === 0 ? 0 : (dataRowModalIcon.precoComStComDesconto / dataRowModalIcon.arqFltCustoMedio - 1) * 100;
      if (data.length > 0) {
        updateDataModalIcon(
          <div className="my-2">
            <p>Estoque da Filial:</p>
            <TableHeaderStyled>
              <Table>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center' }}>Filial</th>
                    <th style={{ textAlign: 'left' }}>Peça</th>
                    <th style={{ textAlign: 'center' }}>Sufixo</th>
                    <th style={{ textAlign: 'right' }}>Quantidade</th>
                    <th style={{ textAlign: 'right' }}>Cst Médio</th>
                    <th style={{ textAlign: 'right' }}>Var Prç Camp x Cst Méd</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">{dataRowModalIcon?.filIntIdFilial}</td>
                    <td align="left">{dataRowModalIcon.fitStrNomeItemCampanha}</td>
                    <td align="center">{dataRowModalIcon.fitStrCodFabricante}</td>
                    <td align="right">{dataRowModalIcon.caaIntQtdEstoque}</td>
                    <td align="right">{'R$ ' + (Math.ceil(dataRowModalIcon.arqFltCustoMedio * 100) / 100).toFixed(2)}</td>
                    <td align="center">{dataRowModalIconDelta.toFixed(2)}%</td>
                  </tr>
                </tbody>
              </Table>
            </TableHeaderStyled>
            <p className="mt-4">Peças disponíveis em outras filiais:</p>
            <TableHeaderStyled>
              <Table size="sm" style={{ cursor: 'pointer' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center' }}>Filial</th>
                    <th style={{ textAlign: 'center' }}>Base</th>
                    <th style={{ textAlign: 'right' }}>Pend</th>
                    <th style={{ textAlign: 'right' }}>Bloq</th>
                    <th style={{ textAlign: 'center' }}>CVF</th>
                    <th style={{ textAlign: 'left' }}>Status</th>
                    <th style={{ textAlign: 'right' }}>Exc</th>
                    <th style={{ textAlign: 'right' }}>Qtd Disp</th>
                    <th style={{ textAlign: 'right' }}>Prç Rep</th>
                    <th style={{ textAlign: 'right' }}>Cst Médio</th>
                    <th style={{ textAlign: 'right' }}>Var Prç Camp x Cst Méd</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((value: any, index: number) => {
                    let delta = value.custoMedio === 0 ? 0 : (dataRowModalIcon.precoComStComDesconto / value.custoMedio - 1) * 100;
                    return (
                      <tr key={index}>
                        <td align="center">{value.siglaFilial}</td>
                        <td align="center">{value.base}</td>
                        <td align="right">{value.pendente}</td>
                        <td align="right">{value.bloqueado}</td>
                        <td align="center">{value.curva}</td>
                        <td align="left">{value.status}</td>
                        <td align="right">{value.excesso}</td>
                        <td align="right">{value.estoque}</td>
                        <td align="right">{value.precoReposicao}</td>
                        <td align="right">{'R$ ' + (Math.ceil(value.custoMedio * 100) / 100).toFixed(2)}</td>
                        <td align="center">{delta.toFixed(2)}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </TableHeaderStyled>
          </div>
        );
      } else {
        updateDataModalIcon(
          <>
            <p>sem dados</p>
          </>
        );
      }
    } else {
      closeIcon();
    }
  }

  async function handleGraphicHistory() {
    let response = await graphicHistory(dataRowModalIcon.arqIntCodIteCliente);
    if (response.statusCode === 200) {
      let data = response.body.map((value: any) => {
        return {
          name: value.anoMes,
          precoReal: value.precoReal,
          precoReposicao: value.precoReposicao,
          precoVenda: value.precoVenda,
        };
      });

      if (data.length > 0) {
        updateDataModalIcon(<Graphic data={data} />);
      } else {
        updateDataModalIcon(
          <>
            <p>sem dados</p>
          </>
        );
      }
    } else {
      closeIcon();
    }
  }

  function Graphic(params: { data: any }) {
    return (
      <LineChart width={750} height={300} data={params.data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="precoReal" stroke="#8884d8" activeDot={{ r: 8 }} />
        <Line type="monotone" dataKey="precoReposicao" stroke="#79aed2" />
        <Line type="monotone" dataKey="precoVenda" stroke="#82ca9d" />
      </LineChart>
    );
  }

  async function handleObservationItem() {
    let response = await observationItem({ fitStrCodFabricante: dataRowModalIcon.fitStrCodFabricante, filial: branchSelected?.value });
    if (response.statusCode === 200) {
      if (response.body.length > 0) {
        updateDataModalIcon(
          <TableHeaderStyled>
            <Table className="mt-3">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Mensagem</th>
                </tr>
              </thead>
              <tbody>
                {response.body.map((value: any, index: number) => {
                  return (
                    <tr key={index}>
                      <td>{value.id}</td>
                      <td>{value.mensagem}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </TableHeaderStyled>
        );
      } else {
        updateDataModalIcon(
          <>
            <p>sem dados</p>
          </>
        );
      }
    } else {
      closeIcon();
    }
  }

  async function handlehandleMovement(typeMoviment: string) {
    let response = await movement({ codigoItem: dataRowModalIcon.codigo, idFilial: dataRowModalIcon.filial, typeMoviment: typeMoviment });
    if (response.statusCode === 200) {
      if (response.body.length > 0) {
        updateDataModalIcon(
          <TableHeaderStyled>
            <Table className="mt-3">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Empresa</th>
                  <th style={{ textAlign: 'left' }}>Filial</th>
                  <th style={{ textAlign: 'right' }}>Quantidade</th>
                  <th style={{ textAlign: 'right' }}>Valor</th>
                </tr>
              </thead>
              <tbody>
                {response.body.map((value: any, index: number) => {
                  let valorFormatado = Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(value.valor);
                  return (
                    <tr key={index}>
                      <td align="left">{value.nomeEmpresa}</td>
                      <td align="left">{value.nomeFilial}</td>
                      <td align="right">{value.quantidade}</td>
                      <td align="right">{valorFormatado}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </TableHeaderStyled>
        );
      } else {
        updateDataModalIcon(
          <>
            <p>sem dados</p>
          </>
        );
      }
    } else {
      closeIcon();
    }
  }

  async function handlehandleCorrelate() {
    let response = await correlate({ codigoItem: dataRowModalIcon.codigo });
    if (response.statusCode === 200) {
      if (response.body.length > 0) {
        updateDataModalIcon(
          <>
            <p>Item(s) Correlatos:</p>
            <TableHeaderStyled>
              <Table className="mt-1">
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center' }}>Código</th>
                    <th style={{ textAlign: 'left' }}>Nome</th>
                    <th style={{ textAlign: 'right' }}>Estoque</th>
                  </tr>
                </thead>
                <tbody>
                  {response.body.map((value: any, index: number) => {
                    return (
                      <tr key={index}>
                        <td align="center">{value.codigo}</td>
                        <td align="left">{value.nome}</td>
                        <td align="right">{value.estoque}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </TableHeaderStyled>
          </>
        );
      } else {
        updateDataModalIcon(
          <>
            <p>sem dados</p>
          </>
        );
      }
    } else {
      closeIcon();
    }
  }

  /**
   *
   *
   *
   *
   *  demandas */
  const today = new Date();
  const periodsMonths = datePeriodsMonths(today, 7);

  function lastMonth(date: string | number | Date, diff: number) {
    const listMonths = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    const d = new Date(date);
    let ano = d.getFullYear();
    let month = d.getMonth() - diff;
    if (month < 0) {
      month = month + 12;
      ano = ano - 1;
    }
    return `${listMonths[month]}/${ano}`;
  }

  function datePeriodsMonths(data: string | number | Date, numberOfMonths: number) {
    const datas = [];
    for (let i = 0; i < numberOfMonths; i++) {
      datas.push(lastMonth(data, i));
    }
    return datas;
  }

  function confirmarNomePedido() {
    updateShowModalNomePedido(false);
    requestOrder(idIntencaoCompra!, nomePedido);
  }

  function verificaFluxoAprovacao() {
    if (fluxoAprovacao !== null && fluxoAprovacao) {
      updateNomePedido('');
      updateShowModalNomePedido(true);
    } else if (campaignSelected?.campanhaFull === true) {
      openModalPii();
    } else {
      updateDadosPiiSend(undefined);
      openModalConfirmAction();
    }
  }

  function onClickCheckboxRow(model: any[], value: any, checked: boolean) {
    updateListTable(
      model.map((item: any) => {
        if (item.arqIntCodIteCliente === value.arqIntCodIteCliente) {
          item.checked = checked;
        }
        return item;
      })
    );
  }

  let labelBotaoEnviarFrabrica = fluxoAprovacao ? 'Solicitar Aprovação' : 'Enviar para Fábrica';

  return (
    <>
      <div>
        <div className="mx-5">
          <TitleGroupComponent titlePage={titlePage} planningName={planningName}>
            <Row>
              <Col className="d-flex align-items-center justify-content-end">
                <Button
                  variant="outline-primary"
                  className="d-flex align-items-center"
                  onClick={showPlanning}
                  size="sm"
                  disabled={campaignSelected === null || campaignSelected === undefined}
                >
                  {itemPlanning > 0 ? (
                    <Badge bg="danger" className="me-2">
                      {itemPlanning}
                    </Badge>
                  ) : (
                    <></>
                  )}
                  <BsSliders className="me-1" />
                  Planejamento
                </Button>
                <div>
                  <Button variant="outline-primary" className="d-flex align-items-center" onClick={onClickExportarExcel} size="sm"
                    disabled={listTable.length === 0 || campaignSelected === null || campaignSelected === undefined || idIntencaoCompra === undefined}
                  >
                    Exportar
                  </Button>
                </div>
                <div data-tip data-for="enviar_pedido">
                  <Button
                    className="ms-1"
                    variant="primary"
                    onClick={verificaFluxoAprovacao}
                    size="sm"
                    disabled={
                      listTable.length === 0 ||
                      campaignSelected === null ||
                      campaignSelected === undefined ||
                      idIntencaoCompra === undefined ||
                      fluxoAprovacao === null
                    }
                  >
                    {labelBotaoEnviarFrabrica}
                  </Button>
                </div>
                {(listTable.length === 0 || campaignSelected === null || campaignSelected === undefined) && (
                  <ReactTooltip id="enviar_pedido" place="top" backgroundColor={'#DC3444'} border>
                    <span>Selecione Uma Campanha!</span>
                  </ReactTooltip>
                )}
              </Col>
            </Row>
          </TitleGroupComponent>
        </div>

        <div className="mx-3">
          <>
            <Card>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-end">
                  <div className="d-flex justify-content-start align-items-end">
                    <div className="mx-1" style={{ width: 300, zIndex: 100 }}>
                      <Form.Label>Filial:</Form.Label>
                      <Select
                        value={branchSelected}
                        options={branchOptions}
                        onChange={(val) => {
                          handleSelectedBranch(val)
                        }}
                        isDisabled={branchOptions === undefined}
                        placeholder="Selecione a Filial"
                      />
                    </div>
                    <div className="mx-1" style={{ width: 300, zIndex: 100 }}>
                      <Form.Label>Campanha:</Form.Label>
                      <Select
                        key={branchSelected?.value}
                        value={campaignSelected}
                        options={campaignsOptions}
                        onChange={(val) => handleSelectedCampaign(val)}
                        isDisabled={branchSelected === undefined && campaignsOptions === undefined}
                        placeholder="Selecione a campanha"
                      />
                    </div>
                  </div>
                </div>
                {listTable.length > 0 ? (
                  <>
                    <div className="mt-3">
                      <ActiveCampaignTotalsCard activeCampaignTotals={activeCampaigntotals!} />
                      <Row md={'auto'}>
                        <Col className="d-flex align-items-center justify-content-between">
                          <Button variant="outline-primary" onClick={showColumn} size={'sm'} className="d-flex align-items-center">
                            <BiColumns />
                          </Button>
                        </Col>
                      </Row>
                    </div>
                    <div className="mt-3">
                      <div className="wrapper">
                        <div style={{ overflow: 'auto', height: '500px', font: 'Open Sans', fontSize: '12px' }}>
                          <Table>
                            <thead>
                              <tr className="m-0 p-0">
                                <th key={'headerSelect'} className="m-0 p-0 sticky-col checkbox-col-header"></th>
                                {columns.map((value, index) => {
                                  freeze = value.order <= 7 ? true : false;

                                  if (freeze && value.order === 1) freezeCss = firstColHeader;
                                  else if (freeze && value.order === 2) freezeCss = secondColHeader;
                                  else if (freeze && value.order === 3) freezeCss = thirdColHeader;
                                  else if (freeze && value.order === 4) freezeCss = fourthColHeader;
                                  else if (freeze && value.order === 5) freezeCss = fifthColHeader;
                                  else if (freeze && value.order === 6) freezeCss = sixthColHeader;
                                  else if (freeze && value.order === 7) freezeCss = seventhColHeader;
                                  else freezeCss = '';

                                  let align = value.align;

                                  let classNameDiv = `d-flex align-items-center justify-content-${align} mx-2`;
                                  if (align === 'left') classNameDiv = `d-flex align-items-center justify-content-start mx-2`;
                                  if (align === 'right') classNameDiv = `d-flex align-items-center justify-content-end mx-2`;

                                  if (value.dataField === 'obsStrTipo' || value.dataField === 'arqIntCodIteCliente') {
                                    return null;
                                  }

                                  if (value.hidden === false) {
                                    if (value.dataField === 'demandas') {
                                      return periodsMonths.map((month, indexMonth) => {
                                        return (
                                          <th className={freeze ? `sticky-col ${freezeCss}` : 'active-campaign-th'} key={indexMonth}>
                                            <div className="d-flex align-items-center">
                                              <p style={{ whiteSpace: 'nowrap' }} className="m-2">
                                                {month}
                                              </p>
                                            </div>
                                          </th>
                                        );
                                      });
                                    }

                                    return value.ordination ? (
                                      <th
                                        align={value.align}
                                        className={freeze ? `px-1 th sticky-col ${freezeCss}` : 'px-1 active-campaign-th'}
                                        key={value.dataField ?? index}
                                        onClick={() => {
                                          orderValueColums(value, LOCALSTORAGE_COLUMS_ORDER, columns, totalPageSize, handleTable, nextPagination);
                                        }}
                                      >
                                        <div className={classNameDiv}>
                                          <div className="d-flex align-items-center justify-content-center">
                                            <p
                                              style={{
                                                whiteSpace: 'nowrap',
                                              }}
                                              className="m-1"
                                            >
                                              {value.text}
                                            </p>
                                            <CreateIconOrder nameColumn={value.ordination} />
                                          </div>
                                        </div>
                                      </th>
                                    ) : (
                                      <th
                                        align={value.align}
                                        className={freeze ? `px-1 th sticky-col ${freezeCss}` : 'px-1 active-campaign-th'}
                                        style={{ cursor: 'default' }}
                                        key={value.dataField ?? `${value.text}_${index}`}
                                      >
                                        <div className={classNameDiv}>
                                          <div className="d-flex align-items-center justify-content-center">
                                            <p
                                              style={{
                                                whiteSpace: 'nowrap',
                                              }}
                                              className="m-1"
                                            >
                                              {value.text}
                                            </p>
                                          </div>
                                        </div>
                                      </th>
                                    );
                                  }
                                  return null;
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {listTable.map((value, index) => {
                                return (
                                  <tr
                                    key={value['arqIntCodIteCliente'] ?? value['fitStrCodFabricante'] ?? index}
                                    className="text-center"
                                    style={{ background: value['checked'] === true ? '#F2F2F2' : '#FFFFFF' }}
                                  >
                                      <td key={'checkbox' + index} className={`m-0 p-0 mx-2 checkbox-col sticky-col`}>
                                        <Form.Check
                                          type="checkbox"
                                          className=""
                                          onChange={(e) => {
                                            onClickCheckboxRow(listTable, value, e.target.checked);
                                          }}
                                          checked={value['checked']}
                                        />
                                      </td>
                                      {columns.map((vc, i) => {
                                        const delayShow = 0;
                                        const delayHide = 0;
                                        freezeBody = vc.order <= 7 ? true : false;

                                        if (freezeBody && vc.order === 1) freezeCss = firstCol;
                                        else if (freezeBody && vc.order === 2) freezeCss = secondCol;
                                        else if (freezeBody && vc.order === 3) freezeCss = thirdCol;
                                        else if (freezeBody && vc.order === 4) freezeCss = fouthCol;
                                        else if (freezeBody && vc.order === 5) freezeCss = fifthCol;
                                        else if (freezeBody && vc.order === 6) freezeCss = sixthCol;
                                        else if (freezeBody && vc.order === 7) freezeCss = seventhCol;
                                        else freezeCss = '';

                                        if (vc.dataField === 'obsStrTipo' || vc.dataField === 'arqIntCodIteCliente') {
                                          return null;
                                        }

                                        if (vc.dataField === 'ALERTA' && value['aacStrDeltaLegenda'] !== 'cinza') {
                                          const sizeIcon = 15;

                                          const elements: React.ReactElement[] = [
                                            <div key={'saldo' + value['arqIntCodIteCliente']}>
                                              <Button
                                                data-tip
                                                data-for="saldo"
                                                variant="none"
                                                size="sm"
                                                className="m-0 p-0 alert-bg border-0"
                                                onClick={() => {
                                                  showIcon();
                                                  handleRowValueUpdate('Saldo', value);
                                                }}
                                              >
                                                <MdMapsHomeWork size={sizeIcon} color="#017BFE" />
                                              </Button>
                                              <ReactTooltip id="saldo"
                                                delayShow={delayShow}
                                                delayHide={delayHide}
                                                backgroundColor={'#017BFE'}
                                                border
                                                place="left">
                                                <span>Saldo em outras lojas</span>
                                              </ReactTooltip>
                                            </div>,
                                            <div key={'historico' + value['arqIntCodIteCliente']}>
                                              <div >
                                                <Button
                                                  data-tip
                                                  data-for="historico"
                                                  variant="none"
                                                  size="sm"
                                                  className="m-0 p-0 alert-bg border-0"
                                                  onClick={() => {
                                                    showIcon();
                                                    handleRowValueUpdate('Histórico', value);
                                                  }}
                                                >
                                                  <MdAttachMoney size={sizeIcon} color="#017BFE" />
                                                </Button>
                                              </div>
                                              <ReactTooltip id="historico"
                                                type="warning"
                                                delayShow={delayShow}
                                                delayHide={delayHide}
                                                backgroundColor={'#017BFE'}
                                                border
                                                place='left'>
                                                <span>Histórico de preço</span>
                                              </ReactTooltip>
                                            </div>,
                                          ];

                                          if (value['obsStrTipo'] !== null) {
                                            if (value['obsStrTipo'] === '1_Informacao') {
                                              elements.push(
                                                <div key={value['arqIntCodIteCliente'] + '_4'}>
                                                  <Button
                                                    data-tip
                                                    data-for="obsStrTipo1"
                                                    variant="none"
                                                    size="sm"
                                                    className="m-0 p-0 alert-bg border-0"
                                                    onClick={() => {
                                                      showIcon();
                                                      handleRowValueUpdate('Observação', value);
                                                    }}
                                                  >
                                                    <FiAlertTriangle size={sizeIcon} color="#017BFE" />
                                                  </Button>
                                                  <ReactTooltip
                                                    id="obsStrTipo1"
                                                    delayShow={delayShow}
                                                    delayHide={delayHide}
                                                    type="warning"
                                                    backgroundColor={'#017BFE'}
                                                    border
                                                    place="left">
                                                    <span>Infomação</span>
                                                  </ReactTooltip>
                                                </div>
                                              );
                                            }
                                            if (value['obsStrTipo'] === '2_Alerta') {
                                              elements.push(
                                                <div key={value['arqIntCodIteCliente'] + '_4'}>
                                                  <Button
                                                    data-tip
                                                    data-for="obsStrTipo2"
                                                    variant="none"
                                                    size="sm"
                                                    className="m-0 p-0 alert-bg border-0"
                                                    onClick={() => {
                                                      showIcon();
                                                      handleRowValueUpdate('Observação', value);
                                                    }}
                                                  >
                                                    <GrCircleInformation size={sizeIcon} color="#017BFE" />
                                                  </Button>
                                                  <ReactTooltip
                                                    id="obsStrTipo2"
                                                    delayShow={delayShow}
                                                    delayHide={delayHide}
                                                    type="warning"
                                                    backgroundColor={'#017BFE'}
                                                    border
                                                    place="left">
                                                    <span>Alerta</span>
                                                  </ReactTooltip>
                                                </div>
                                              );
                                            }
                                            if (value['obsStrTipo'] === '3_Critico') {
                                              elements.push(
                                                <div key={value['arqIntCodIteCliente'] + '_4'}>
                                                  <Button
                                                    data-tip
                                                    data-for="obsStrTipo3"
                                                    variant="none"
                                                    size="sm"
                                                    className="m-0 p-0 alert-bg border-0"
                                                    onClick={() => {
                                                      showIcon();
                                                      handleRowValueUpdate('Observação', value);
                                                    }}
                                                  >
                                                    <GrStatusCritical size={sizeIcon} color="#017BFE" />
                                                  </Button>
                                                  <ReactTooltip
                                                    id="obsStrTipo3"
                                                    delayShow={delayShow}
                                                    delayHide={delayHide}
                                                    type="warning"
                                                    backgroundColor={'#017BFE'}
                                                    border
                                                    place="left">
                                                    <span>Crítico</span>
                                                  </ReactTooltip>
                                                </div>
                                              );
                                            }
                                            if (value['obsStrTipo'] === '4_Oferta_Aberta') {
                                              elements.push(
                                                <div key={value['arqIntCodIteCliente'] + '_4'}>
                                                  <Button
                                                    data-tip
                                                    data-for="obsStrTipo4"
                                                    variant="none"
                                                    size="sm"
                                                    className="m-0 p-0 alert-bg border-0"
                                                    onClick={() => {
                                                      showIcon();
                                                      handleRowValueUpdate('Observação', value);
                                                    }}
                                                  >
                                                    <BsTag size={sizeIcon} color="#017BFE" />
                                                  </Button>
                                                  <ReactTooltip
                                                    id="obsStrTipo4"
                                                    delayShow={delayShow}
                                                    delayHide={delayHide}
                                                    type="warning"
                                                    backgroundColor={'#017BFE'}
                                                    border
                                                    place="left">
                                                    <span>Oferta Aberta</span>
                                                  </ReactTooltip>
                                                </div>
                                              );
                                            }
                                            if (value['obsStrTipo'] === '5_Oferta_Pedido') {
                                              elements.push(
                                                <div key={value['arqIntCodIteCliente'] + '_4'}>
                                                  <Button
                                                    data-tip
                                                    data-for="obsStrTipo5"
                                                    variant="none"
                                                    size="sm"
                                                    className="m-0 p-0 alert-bg border-0"
                                                    onClick={() => {
                                                      showIcon();
                                                      handleRowValueUpdate('Observação', value);
                                                    }}
                                                  >
                                                    <BsFillCartFill size={sizeIcon} color="#017BFE" />
                                                  </Button>
                                                  <ReactTooltip
                                                    id="obsStrTipo5"
                                                    delayShow={delayShow}
                                                    delayHide={delayHide}
                                                    type="warning"
                                                    backgroundColor={'#017BFE'}
                                                    border
                                                    place="left">
                                                    <span>Oferta Pedido</span>
                                                  </ReactTooltip>
                                                </div>
                                              );
                                            }
                                            if (value['obsStrTipo'] === '6_Alerta_Automatico') {
                                              elements.push(
                                                <div key={value['arqIntCodIteCliente'] + '_4'}>
                                                  <Button
                                                    data-tip
                                                    data-for="obsStrTipo6"
                                                    variant="none"
                                                    size="sm"
                                                    className="m-0 p-0 alert-bg border-0"
                                                    onClick={() => {
                                                      showIcon();
                                                      handleRowValueUpdate('Observação', value);
                                                    }}
                                                  >
                                                    <HiBell size={sizeIcon} color="#017BFE" />
                                                  </Button>
                                                  <ReactTooltip
                                                    id="obsStrTipo6"
                                                    delayShow={delayShow}
                                                    delayHide={delayHide}
                                                    type="warning"
                                                    backgroundColor={'#017BFE'}
                                                    border
                                                    place="left">
                                                    <span>Alerta Automático</span>
                                                  </ReactTooltip>
                                                </div>
                                              );
                                            }
                                          }

                                          return (
                                            <td
                                              key={value['arqIntCodIteCliente'] + '_7'}
                                              className={freezeBody ? `m-0 p-0 sticky-col ${freezeCss}` : 'm-0 p-0'}
                                              style={{ background: value['checked'] === true ? '#F2F2F2' : '#FFFFFF' }}
                                            >
                                              <div className="d-flex align-items-center justify-content-start m-0 p-0  my-1">
                                                <div key={value['arqIntCodIteCliente'] + '_8'} className="d-flex align-items-center justify-content-start">
                                                  {elements}
                                                </div>
                                              </div>
                                            </td>
                                          );
                                        }

                                        if (vc.dataField === 'qtdPendente') {
                                          let borderWidth = value['qtdPendente'] > 0 ? 3 : 1;
                                          let borderColor = value['qtdPendente'] > 0 ? '#32B529' : '';

                                          return (
                                            <td
                                              key={value['qtdPendente'] + '_' + value['id']}
                                              className={freezeBody ? `m-0 p-0 mx-2 sticky-col ${freezeCss}` : 'm-0 p-0 mx-2'}
                                              style={{ background: value['checked'] === true ? '#F2F2F2' : '#FFFFFF' }}
                                            >
                                              <div className="d-flex align-items-center m-0 p-0 mx-2">
                                                <div>
                                                  <Form.Control
                                                    disabled={value['bloquadoCompra']}
                                                    className={`m-0 p-0 mx-2`}
                                                    type="number"
                                                    min="0"
                                                    defaultValue={value['qtdPendente']}
                                                    size="sm"
                                                    style={{
                                                      width: 50,
                                                      borderWidth: borderWidth,
                                                      borderColor: borderColor,
                                                    }}
                                                    onBlur={(event) => {
                                                      handleInputBlurQuantity(event, value);
                                                    }}
                                                    onFocus={handleOnFocusQuantity()}
                                                    onKeyDown={(evt) =>
                                                      (evt.key === 'e' || evt.key === '-' || evt.key === '.' || evt.key === ',' || evt.key === "'") &&
                                                      evt.preventDefault()
                                                    }
                                                  />
                                                </div>
                                                {value['bloquadoCompra'] && (
                                                  <>
                                                    <AiFillLock data-tip data-for="bloqueado" size={18} className="m-1 ms-2" color={'#6C757D'} />
                                                    <ReactTooltip id="bloqueado" backgroundColor={'#6C757D'} delayShow={delayShow} delayHide={delayHide} border place="left">
                                                      <span>Item bloqueado para compra</span>
                                                    </ReactTooltip>
                                                  </>
                                                )}
                                              </div>
                                            </td>
                                          );
                                        }

                                        if (vc.hidden === false) {
                                          if (vc.dataField === 'percentualDesconto' && value[vc.dataField] === null) {
                                            return (
                                              <td
                                                key={value['percentualDesconto'] + value['id'] + '_' + i}
                                                className={freezeBody ? `m-0 p-0 mx-2 sticky-col ${freezeCss}` : 'm-0 p-0 mx-2'}
                                                style={{
                                                  textAlign: vc.align,
                                                  whiteSpace: 'nowrap',
                                                  fontWeight: 250,
                                                  background: value['checked'] === true ? '#F2F2F2' : '#FFFFFF',
                                                }}
                                              >
                                                <div className="m-0 p-0 mx-3 my-1">0 %</div>
                                              </td>
                                            );
                                          }

                                          if (vc.dataField !== 'aacFltDelta' && (value[vc.dataField] === null || value[vc.dataField] === undefined)) {
                                            return (
                                              <td
                                                key={vc.dataField + value['id'] + '_' + i}
                                                className={freezeBody ? `m-0 p-0 mx-2 sticky-col ${freezeCss}` : 'm-0 p-0 mx-2'}
                                                style={{
                                                  textAlign: 'center',
                                                  whiteSpace: 'nowrap',
                                                  fontWeight: 250,
                                                  background: value['checked'] === true ? '#F2F2F2' : '#FFFFFF',
                                                }}
                                              >
                                                <div className="m-0 p-0 mx-3 my-1">{''}</div>
                                              </td>
                                            );
                                          }

                                          if (vc.dataField === 'aacFltDelta' || typeof value[vc.dataField] === 'number') {
                                            let formatted = value[vc.dataField];
                                            if (vc.numberFormat === 'currency') {
                                              formatted = Intl.NumberFormat('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL',
                                              }).format(formatted);
                                            }

                                            if (vc.numberFormat === 'percent') {
                                              if (vc.dataField === 'aacFltDelta') {
                                                let deltaIcon: React.ReactElement = <></>;
                                                if (value['aacStrDeltaLegenda'] === 'verde') {
                                                  deltaIcon = (
                                                    <div style={{ minWidth: '70px', textAlign: 'left' }}>
                                                      <span>
                                                        <FaDotCircle data-tip data-for={"delta_verde" + value['arqIntCodIteCliente']} size={15} color={'#28A745'} /> {formatted}%
                                                      </span>
                                                      <ReactTooltip id={"delta_verde" + value['arqIntCodIteCliente']} place="left" delayShow={delayShow} delayHide={delayHide} backgroundColor={'#28A745'} border>
                                                        <span>Preço da campanha menor que o seu custo médio</span>
                                                      </ReactTooltip>
                                                    </div>
                                                  );
                                                }

                                                if (value['aacStrDeltaLegenda'] === 'amarelo') {
                                                  deltaIcon = (
                                                    <div style={{ minWidth: '70px', textAlign: 'left' }}>
                                                      <span>
                                                        <FaDotCircle data-tip data-for={"delta_amarelo" + value['arqIntCodIteCliente']} size={15} color={'#f2e941'} /> {formatted}%
                                                      </span>
                                                      <ReactTooltip id={"delta_amarelo" + value['arqIntCodIteCliente']} place="left" delayShow={delayShow} delayHide={delayHide} backgroundColor={'#f2e941'} textColor="black" border>
                                                        <span>Preço da campanha igual ou maior que o seu custo médio - 10%</span>
                                                      </ReactTooltip>
                                                    </div>
                                                  );
                                                }

                                                if (value['aacStrDeltaLegenda'] === 'cinza') {
                                                  deltaIcon = (
                                                    <div style={{ minWidth: '70px', textAlign: 'center' }}>
                                                      <span>
                                                        <FaDotCircle data-tip data-for={"delta_cinza" + value['arqIntCodIteCliente']} size={15} color={'#d8d8d8'} />
                                                      </span>
                                                      <ReactTooltip id={"delta_cinza" + value['arqIntCodIteCliente']} place="left" delayShow={delayShow} delayHide={delayHide} backgroundColor={'#d8d8d8'} textColor="black" border>
                                                        <span>Itens indisponíveis em estoque</span>
                                                      </ReactTooltip>
                                                    </div>
                                                  );
                                                }

                                                if (value['aacStrDeltaLegenda'] === 'vermelho') {
                                                  deltaIcon = (
                                                    <div style={{ minWidth: '70px', textAlign: 'left' }}>
                                                      <span>
                                                        <FaDotCircle data-tip data-for={"delta_vermelho" + value['arqIntCodIteCliente']} size={15} color={'#DC3444'} /> {formatted}%
                                                      </span>
                                                      <ReactTooltip id={"delta_vermelho" + value['arqIntCodIteCliente']} place="left" delayShow={delayShow} delayHide={delayHide} backgroundColor={'#DC3444'} border>
                                                        <span>Preço da campanha maior que (10%) o seu custo médio</span>
                                                      </ReactTooltip>
                                                    </div>
                                                  );
                                                }
                                                return (
                                                  <td
                                                    key={value['id'] + '_' + i}
                                                    className={freezeBody ? `m-0 p-0 sticky-col ${freezeCss}` : 'm-0 p-0'}
                                                    style={{ background: value['checked'] === true ? '#F2F2F2' : '#FFFFFF' }}
                                                  >
                                                    <div className="d-flex align-items-center justify-content-center m-0 p-0  my-1">
                                                      <div className="d-flex align-items-center justify-content-center">{deltaIcon}</div>
                                                    </div>
                                                  </td>
                                                );
                                              } else {
                                                formatted = `${formatted}%`;
                                              }
                                            }

                                            if (vc.typeField === 'monetary' && formatted !== undefined) {
                                              formatted = formatted.toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL',
                                              });
                                            }

                                            return (
                                              <td
                                                key={value[vc.dataField] + value['id'] + '_' + i}
                                                className={freezeBody ? `m-0 p-0 mx-2 sticky-col ${freezeCss}` : 'm-0 p-0 mx-2'}
                                                style={{
                                                  textAlign: vc.align,
                                                  whiteSpace: 'nowrap',
                                                  fontWeight: 250,
                                                  background: value['checked'] === true ? '#F2F2F2' : '#FFFFFF',
                                                }}
                                              >
                                                <div className="m-0 p-0 mx-3 my-1">{formatted}</div>
                                              </td>
                                            );
                                          }

                                          if (typeof value[vc.dataField] === 'string') {
                                            let formatted = value[vc.dataField];
                                            if (vc.typeField === 'monetary') {
                                              formatted = formatted.toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL',
                                              });
                                            }

                                            if (vc.typeField === 'dateTime') {
                                              if (formatted === null) {
                                                formatted = 'N/A';
                                              } else {
                                                formatted = ParseDateToBrV2(formatted);
                                              }
                                            }

                                            return (
                                              <td
                                                key={value[vc.dataField] + value['id'] + '_' + i}
                                                className={freezeBody ? `m-0 p-0 mx-2 sticky-col ${freezeCss}` : 'm-0 p-0 mx-2'}
                                                style={{
                                                  textAlign: vc.align,
                                                  whiteSpace: 'nowrap',
                                                  fontWeight: 250,
                                                  background: value['checked'] === true ? '#F2F2F2' : '#FFFFFF',
                                                }}
                                              >
                                                <div data-tip
                                                  data-for={'tooltip_desc' + value[vc.dataField]}
                                                  className="m-0 p-0 mx-3 my-1"
                                                  style={{
                                                    display: '-webkit-box`',
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                  }}>{formatted}</div>
                                                {(vc.dataField === 'fitStrNomeItemCampanha') && <ReactTooltip
                                                  id={'tooltip_desc' + value[vc.dataField]}
                                                  place='left'
                                                  delayShow={delayShow}
                                                  delayHide={delayHide}
                                                  backgroundColor={'#FFFFFF'}
                                                  textColor="black"
                                                  border
                                                >
                                                  <span>{value[vc.dataField]}</span>
                                                </ReactTooltip>}
                                              </td>
                                            );
                                          }

                                          if (vc.dataField === 'demandas') {
                                            return value['demandas'].map((month: any, indexMonth: number) => {
                                              return (
                                                <td
                                                  key={indexMonth}
                                                  className={freezeBody ? `m-0 p-0 sticky-col ${freezeCss}` : 'm-0 p-0'}
                                                  style={{
                                                    textAlign: vc.align,
                                                    whiteSpace: 'nowrap',
                                                    fontWeight: 250,
                                                    background: value['checked'] === true ? '#F2F2F2' : '#FFFFFF',
                                                  }}
                                                >
                                                  {month}
                                                </td>
                                              );
                                            });
                                          }
                                        }
                                        return null;
                                      })}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <Row className="d-flex align-items-start justify-content-between">
                        <Col className="d-flex justify-content-start"></Col>
                        <Col>
                          <div className="d-flex justify-content-center">
                            <Pagination size="sm">
                              <Pagination.First onClick={onClickFirstPagination}>Primeira</Pagination.First>
                              <Pagination.Prev onClick={onClickPrevPagination}>Anterior</Pagination.Prev>
                              {paginationItemList?.map((value, key) => {
                                return (
                                  <Pagination.Item key={key} active={value.active} onClick={() => onClickItemPagination(value)}>
                                    {value.item + 1}
                                  </Pagination.Item>
                                );
                              })}
                              <Pagination.Next onClick={onClickNextPagination}>Próxima</Pagination.Next>
                              <Pagination.Last onClick={onClickLastPagination}>Última</Pagination.Last>
                            </Pagination>
                          </div>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <Button
                            variant="outline-danger"
                            onClick={removeQuantities}
                            size={'sm'}
                          >
                            Zerar Valores Salvos
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="d-flex align-items-center justify-content-center" style={{ height: '60vh' }}>
                      <p className="m-5">A busca não retorna nada, verifique o Planejamento ou clique em Processar</p>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </>
        </div>
        <Footer />
      </div>

      <ModalOrderHideColumns
        totalPageSize={totalPageSize}
        updateTotalPageSize={updateTotalPageSize}
        columns={columns}
        updateColumns={updateColumns}
        minPageSize={1}
        maxPageSize={13}
        showModalColumns={showModalColumns}
        closeColumn={closeColumn}
        applyAction={async (newColumns: TableDescriptions[]) => {
          closeColumn();
          handleOrderHideColumns(newColumns);
          changeValueListByColums(listTable);
          await handleTable();
        }}
      />
      <ModalPlanning
        applyAction={handleApplyPlanning}
        closePlanning={closePlanning}
        createPlanning={createPlanning}
        editPlanning={editPlanning}
        removePlanning={removePlanning}
        keyPlanningLocalStorage={LOCALSTORAGE_PLANNING}
        listAllPlanning={listAllPlanning}
        namePlanningLocalStorage={LOCALSTORAGE_PLANNING}
        optionsFiltersDefault={optionsFiltersDefault}
        showModalPlanning={showModalPlanning}
      />
      <ModalIcon isLoading={isLoadingModal} closeIcon={closeIcon} dataModalIcon={dataModalIcon} showModalIcon={showModalIcon} typeModalIcon={typeModalIcon} />
      <ModalCampaignPiiData
        showModalPii={showModalPii}
        closeModalPii={closeModalPii}
        meliOptions={meliOptions}
        confirmActionFunction={confirmPiiData}
      />
      <Modal show={showModalNomePedido} onHide={() => updateShowModalNomePedido(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Solicitar Pedido</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label htmlFor="orderNameCampaigns">Nome do pedido:</label>
          <FormControl
            type="text"
            id="orderNameCampaigns"
            placeholder="Nome do pedido"
            maxLength={20}
            value={nomePedido}
            onChange={(e) => updateNomePedido(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => updateShowModalNomePedido(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={confirmarNomePedido}>
            Solicitar
          </Button>
        </Modal.Footer>
      </Modal>
      <ModalConfirmAction
        confirmActionFunction={confirmSendOrder}
        confirmButtonMessage="Enviar"
        closeButtonMessage="Cancelar"
        closeModalConfirmAction={closeModalConfirmAction}
        message="Confirmar o envio do pedido"
        showModalConfirmAction={showModalConfirmAction}
        titleConfirmAction="Enviar Pedido"
      />
    </>
  );
};
